import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderComponent } from '../../header/header.component';

@Component({
  selector: 'app-time-out',
  templateUrl: './time-out.component.html',
  styleUrls: ['./time-out.component.css'],
  imports: [
      TranslateModule,
      HeaderComponent
  ], 
  standalone: true
})
export class TimeOutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    sessionStorage.clear();
    localStorage.removeItem('claimPrint');
    localStorage.removeItem('claimDocumentsList');
    localStorage.removeItem('audiogramDocumentsList');
    // sample code to dynamically load footer when app start
    if (document.getElementById('footerElement')) {
      document.getElementById('footerElement')?.removeAttribute('hidden');
    }
  }

}
